module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "flat": "",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("apps")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    attrs: {
      "href": "http://localhost:8042/"
    }
  }, [_c('v-list-tile-title', {
    staticClass: "black--text"
  }, [_vm._v("Lyrex")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76f28af8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheHeader/TheHeaderMenuApps.vue
// module id = 384
// module chunks = 0